export function triggerModule(root, option) {
    root.dispatchEvent(
        new window.CustomEvent('hopModuleTrigger', {
            detail: option,
        }),
    );
}
